import { render, staticRenderFns } from "./ShowSvgSectionsComponent.vue?vue&type=template&id=7dd4d8c3"
import script from "./ShowSvgSectionsComponent.vue?vue&type=script&lang=js"
export * from "./ShowSvgSectionsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports